
angular.module('app.controllers.faqs', []).controller('FaqsController', ['$rootScope','$scope','$log', '$timeout', '$animate', function ($rootScope, $scope, $log, $timeout, $animate) {

  'use strict';

  $log.debug('FaqsController()');

  $scope.types = ["Top 10 FAQs","Billing and My Account FAQs","Safety FAQs","General FAQs"];
  $scope.shows = [true,false, false,false];
  $scope.typeSelection = 0;
  $scope.oneAtATime = true;
  $scope.status = {};


  $scope.setType = function(value) {
    if (value == $scope.typeSelection)
      return;
    $scope.shows[$scope.typeSelection] = false;
    $scope.typeSelection = value;
    $scope.shows[$scope.typeSelection] = true;
  };

}]);

